import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

console.log('🚀 Loading StreakMaster with routing...');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);

console.log('🚀 StreakMaster loaded successfully!');